import { render } from "./EleHistoryFault.vue?vue&type=template&id=560dd650"
import script from "./EleHistoryFault.vue?vue&type=script&lang=js"
export * from "./EleHistoryFault.vue?vue&type=script&lang=js"

import "./EleHistoryFault.vue?vue&type=style&index=0&id=560dd650&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__